import React from 'react';
import styled from 'styled-components';

import {authImageWidth} from 'styles/shared';

const ImageContainer = styled.div`
  position: relative;
  width: ${authImageWidth};
  border-radius: 6rem;
  background: url(/images/login-bg.svg) no-repeat;
`;

const Image = styled.div`
  position: absolute;
  bottom: -6rem;
  right: -5rem;
  background: url(/images/illustration-people-big.svg) no-repeat;
  width: 49rem;
  height: 62.9rem;
`;

function AuthBackgroundImage() {
  return (
    <ImageContainer>
      <Image />
    </ImageContainer>
  );
}

export default AuthBackgroundImage;
